import _ from 'lodash';
import moment from 'moment';
import rtvService from '../../services/rtvService';
import Ticket from '../../model/contactUs';
import RTV from '../../model/rtv';

const state = {
  baseUrl: '/complain',
  pagination: {},
  tickets: [],
  rtv: [],
  uploadedImages: {},
  oneRtv: {},
  loading: false,
  ticket: null,
  videoUrl: null,
  report: []
};

const actions = {
  uploadImage({ dispatch, commit }, query = {}, router) {
    dispatch('alert/clear', {}, { root: true });
    const { file, urlName } = query;
    rtvService
      .getSignedUrl({ filename: `${new Date()}-${file.name}`, filetype: file.type, file })
      .then(response => {
        rtvService
          .uploadImage({ url: response.data, file })
          .then(res => {
            commit('Nothing', res);
          })
          .catch(e => {
            commit('requestFailed');
            dispatch('common/handleServiceException', { e, router }, { root: true });
          });
        commit('setUrl', { image: response.data, urlName });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  list({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setRtv', { rtv: [], pagination: {} });

    commit('startRequest');

    rtvService
      .list({ query })
      .then(response => {
        commit('setRtv', { rtv: response.data.rows, pagination: response.data.pagination });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  downloadReport({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setReport', { report: [] });

    commit('startRequest');

    rtvService
      .list({ query })
      .then(response => {
        commit('setReport', { tickets: response.data.rows });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { rtv, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    rtvService
      .postOne({ rtv })
      .then(_response => {
        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setOneRtv', { oneRtv: {} });

    rtvService
      .getOne({ id })
      .then(response => {
        commit('setOneRtv', { oneRtv: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { id, rtv, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    rtvService
      .patchOne({ id, rtv })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'Rtv has been updated.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    rtvService
      .deleteOne({ id })
      .then(_response => {
        dispatch('list', { id });
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'RTV has been deleted.'
          },
          { root: true }
        );
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  }
};

const getters = {};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setUrl(state, { image, urlName }) {
    const cleanUrl = image.split('?')[0];
    state.uploadedImages = {
      ...state.uploadedImages,
      [urlName]: cleanUrl
    };
  },
  setRtv(state, { rtv, pagination }) {
    let row = 1;
    state.rtv = _.map(rtv, rtv => {
      const newRtv = new RTV({
        id: rtv._id, // eslint-disable-line
        rowNum: row,
        index: row,
        rtvDate: rtv.rtvDate,
        rtvNumber: rtv.rtvNumber,
        articleCode: rtv.articleCode,
        articleDescription: rtv.articleDescription,
        vendorCode: rtv.vendorCode,
        rtvQuantity: rtv.rtvQuantity,
        rtvValue: rtv.rtvValue,
        isVerified: rtv.isVerified,
        physicalQuantity: rtv.physicalQuantity,
        currentStatus: rtv.currentStatus,
        dateOfPickUp: rtv.dateOfPickUp,
        rtvDocumentUrl: rtv.rtvDocumentUrl,
        passoutSlipUrl: rtv.passoutSlipUrl,
        courierPodUrl: rtv.courierPodUrl,
        dateOfDispatch: rtv.dateOfDispatch,
        storeid: rtv.storeid,
        submittedBy: rtv.submittedBy,
        submittedByName: rtv.submittedByName,
        storeName: rtv.storeName
      });
      row += 1;
      return newRtv;
    });
    // state.rtv = rtv;
    state.pagination = pagination;
    state.loading = false;
  },
  setReport(state, { tickets }) {
    let row = 1;
    state.report = _.map(tickets, ticket => {
      const newTickets = new Ticket({
        id: ticket._id, // eslint-disable-line
        rowNum: row,
        name: ticket.name,
        mobile: ticket.mobile,
        email: ticket.email,
        issue: ticket.issue,
        details: ticket.details,
        priority: ticket.priority,
        storeid: ticket.storeid,
        complainNumber: ticket.complainNumber,
        imageUrl: ticket.imageUrl ? ticket.imageUrl : '-',
        resolvedAt: ticket.resolvedAt,
        escalationTime: ticket.escalationTime ? ticket.escalationTime : '-',
        complainSource: ticket.complainSource,
        currentStatus: ticket.currentStatus,
        isResolved: ticket.isResolved === true ? 'True' : 'False',
        issuePriority: ticket.issuePriority,
        submittedByRole: ticket.submittedByRole ? ticket.submittedByRole.join(',') : '',
        submittedByName: ticket.submittedByName,
        createdAt: ticket.createdAt,
        submittedBy: ticket.submittedBy,
        department: ticket.department,
        subDepartment: ticket.subDepartment,
        viewEdit: ticket.viewEdit,
        tentativeDate: ticket.tentativeDate,
        aging: ticket.aging,
        resolvedImageUrl: ticket.resolvedImageUrl,
        cancelReason: ticket.cancelReason
      });
      row += 1;
      return newTickets;
    });
    state.loading = false;
  },
  setOneRtv(state, { oneRtv }) {
    state.oneRtv = {
      ...oneRtv,
      rtvDate: oneRtv.rtvDate ? moment(oneRtv.rtvDate).format('YYYY-MM-DD') : null,
      dateOfPickUp: oneRtv.dateOfPickUp ? moment(oneRtv.dateOfPickUp).format('YYYY-MM-DD') : null,
      dateOfDispatch: oneRtv.dateOfDispatch ? moment(oneRtv.dateOfDispatch).format('YYYY-MM-DD') : null
    };
    // state.oneRtv = new RTV({
    //   id: oneRtv._id, // eslint-disable-line
    //   rtvDate: oneRtv.rtvDate,
    //   rtvNumber: oneRtv.rtvNumber,
    //   articleCode: oneRtv.articleCode,
    //   articleDescription: oneRtv.articleDescription,
    //   vendorCode: oneRtv.vendorCode,
    //   rtvQuantity: oneRtv.rtvQuantity,
    //   rtvValue: oneRtv.rtvValue,
    //   isVerified: oneRtv.isVerified,
    //   physicalQuantity: oneRtv.physicalQuantity,
    //   currentStatus: oneRtv.currentStatus,
    //   dateOfPickUp: oneRtv.dateOfPickUp,
    //   rtvDocumentUrl: oneRtv.rtvDocumentUrl,
    //   passoutSlipUrl: oneRtv.passoutSlipUrl,
    //   courierPodUrl: oneRtv.courierPodUrl,
    //   dateOfDispatch: oneRtv.dateOfDispatch,
    //   storeid: oneRtv.storeid,
    //   submittedBy: oneRtv.submittedBy,
    //   submittedByName: oneRtv.submittedByName,
    //   storeName: oneRtv.storeName
    // });
    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
